import Vue from 'vue'
import * as GoogleMapsLoader from 'google-maps'
import urlApi from '../../router/urlApi'
import LocationMap from '../google/LocationMap'
import utils from '../../services/utils'

const API_KEY = 'AIzaSyC5JcoGlTUPTGM_8GK9EKiPByA2WVZ2FKA'
// const API_KEY = 'AIzaSyBh_F-m7daA46hvCkYhLMZZiZg4S9mCoX4';
const CORS = 'https://cors-anywhere.herokuapp.com/'

var map
var marker
var circle
var mapaAula

export default {
  distanceBetweenGps(lat_a, lon_a, lat_b, lon_b) {
    const p = 0.0174533
    let cos = Math.cos
    const a =
      0.5 -
      cos((lat_a - lat_b) * p) / 2 +
      (cos(lat_b * p) * cos(lat_a * p) * (1 - cos((lon_a - lon_b) * p))) / 2
    return 12742 * Math.asin(Math.sqrt(a)) * 1000
  },

  getMapPicture(width, height, positions, beginTime, infractions) {
    let self = this
    var fullDistance = 0
    var timer

    GoogleMapsLoader.KEY = API_KEY
    GoogleMapsLoader.VERSION = '3.40'

    function haversineDistance(lat1, lon1, lat2, lon2) {
      const R = 6371e3
      const φ1 = (lat1 * Math.PI) / 180
      const φ2 = (lat2 * Math.PI) / 180
      const Δφ = ((lat2 - lat1) * Math.PI) / 180
      const Δλ = ((lon2 - lon1) * Math.PI) / 180

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

      return R * c
    }

    GoogleMapsLoader.load(google => {
      var mapDiv = document.getElementById('maps')
      mapDiv.style = `width:${width}px; height:${height}px; margin-left: auto; margin-right: auto;`

      var centerPos = new google.maps.LatLng(positions[0].lat, positions[0].lon)

      self.mapaAula = new google.maps.Map(mapDiv, {
        center: { lat: centerPos.lat(), lng: centerPos.lng() },
        zoom: 14.5,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
      })

      const path = positions.map(p => ({
        lat: parseFloat(p.lat),
        lng: parseFloat(p.lon),
      }))

      // Processar infrações e marcadores
      const infractionMarkers = new Map()
      positions.forEach((position, index) => {
        const time = new Date(position.time)

        if (index >= 2) {
          const distance = haversineDistance(
            positions[index - 1].lat,
            positions[index - 1].lon,
            position.lat,
            position.lon
          )
          fullDistance += distance

          // Verificar paradas longas (10 minutos)
          if (distance < 10) {
            if (!timer) {
              timer = time
            } else {
              const minutes = Math.floor(Math.abs(time - timer) / 1000 / 60)
              if (minutes >= 10) {
                new google.maps.Marker({
                  map: self.mapaAula,
                  icon: 'http://maps.google.com/mapfiles/ms/icons/yellow-dot.png',
                  position: { lat: parseFloat(position.lat), lng: parseFloat(position.lon) },
                })
                timer = null
              }
            }
          } else {
            timer = null
          }
        }

        // Processar infrações
        infractions.forEach((infraction, idx) => {
          const infractionTime = new Date(infraction.time).getTime()
          if (
            Math.abs(time.getTime() - infractionTime) <= 30000 &&
            !infractionMarkers.has(idx)
          ) {
            infractionMarkers.set(idx, true)
            new google.maps.Marker({
              map: self.mapaAula,
              icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
              position: { lat: parseFloat(position.lat), lng: parseFloat(position.lon) },
            })
          }
        })
      })

      // Adicionar marcadores de início e fim
      new google.maps.Marker({
        map: self.mapaAula,
        icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
        position: { lat: path[0].lat, lng: path[0].lng },
      })

      new google.maps.Marker({
        map: self.mapaAula,
        icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
        position: {
          lat: path[path.length - 1].lat,
          lng: path[path.length - 1].lng,
        },
      })

      // Desenhar o trajeto
      new google.maps.Polyline({
        map: self.mapaAula,
        path: path,
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 2,
      })

      document.getElementById('distance_gps').innerHTML += `${(fullDistance / 1000).toFixed(1)} Km`
    })
  },

  getMap() {
    GoogleMapsLoader.KEY = API_KEY
    GoogleMapsLoader.VERSION = '3.40'

    GoogleMapsLoader.load(google => {
      var mapDiv = document.getElementById('mapa')
      mapDiv.style = 'width:900px; height:300px; margin-left: auto; margin-right: auto;'

      this.map = new google.maps.Map(mapDiv, {
        center: { lat: -3.7319, lng: -38.5267 },
        zoom: 5,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
      })

      // var marker = `markers=color:green|${lat},${lon}`;

      // var map = new Image();
      // map.src = `https://maps.googleapis.com/maps/api/staticmap?key=${API_KEY}&size=1200x300&maptype=roadmap&${marker}`;
      // map.style.borderRadius = '5px';
      // map.style.border = '1px solid';

      // var mapaDiv = document.getElementById('mapa');
      // while (mapaDiv.firstChild) {
      //   mapaDiv.removeChild(mapaDiv.firstChild);
      // }
      // mapaDiv.appendChild(map);
    })
  },

  panToLocation(address, callback) {
    let self = this
    var url = `https://maps.googleapis.com/maps/api/geocode/json?address=${address.cep}+${address.numero},+${address.municipio},+${address.uf}&key=${API_KEY}`
    var latInput = document.getElementById('lat')
    var lonInput = document.getElementById('lon')

    Vue.http.get(CORS + url).then(response => {
      if (document.getElementById('logradouro').value == 'INDEFINIDO') {
        document.getElementById('logradouro').value =
          response.body.results[0].address_components[0].long_name
      }
      var lat = response.body.results[0].geometry.location.lat
      var lon = response.body.results[0].geometry.location.lng

      latInput.value = lat
      lonInput.value = lon

      self.map.panTo(new google.maps.LatLng(lat, lon))
      self.map.setZoom(15)

      self.marker = new google.maps.Marker({
        map: self.map,
        draggable: true,
        animation: google.maps.Animation.BOUNCE,
        position: { lat: lat, lng: lon },
      })

      self.circle = new google.maps.Circle({
        strokeColor: '#58EE17',
        fillColor: '#58EE17',
        map: self.map,
        center: { lat: lat, lng: lon },
        radius: 500,
      })

      setTimeout(function () {
        self.marker.setAnimation(null)
      }, 1430)

      google.maps.event.addListener(self.marker, 'dragend', function (event) {
        var latEvent = event.latLng.lat()
        var lonEvent = event.latLng.lng()

        latInput.value = latEvent
        lonInput.value = lonEvent

        var loader = document.getElementById('load')
        loader.style.display = 'block'

        Vue.http
          .get(
            `${CORS}https://maps.googleapis.com/maps/api/geocode/json?latlng=${latEvent},${lonEvent}&key=${API_KEY}`
          )
          .then(function (response) {
            var numero = response.body.results[0].address_components[0].long_name
            var cep = response.body.results[0].address_components[6].long_name.split('-')

            var cepInput = document.getElementById('cep')
            var numeroInput = document.getElementById('numero')

            cep = cep[0] + cep[1]

            numeroInput.value = numero
            cepInput.value = cep

            Vue.http.get(urlApi + '/enderecos/' + cep).then(response => {
              if (response.status === 200 && response.data.sucesso) {
                document.getElementById('logradouro').value = response.data.dados.logradouro
                document.getElementById('cidade').value = response.data.dados.municipio
                document.getElementById('uf').value = response.data.dados.uf
                document.getElementById('bairro').value = response.data.dados.bairro
                self.map.panTo({ lat: latEvent, lng: lonEvent })
                self.circle.setCenter({ lat: latEvent, lng: lonEvent })
              } else {
                document.getElementById('logradouro').value = ''
                document.getElementById('cidade').value = ''
                document.getElementById('uf').value = ''
                document.getElementById('bairro').value = ''
              }
              loader.style.display = 'none'
            })
          })

        // self.map.panTo({lat: latEvent, lng: lonEvent});
        // self.circle.setCenter({lat: latEvent, lng: lonEvent});
      })

      return callback(false)
    })
  },
}
